import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { systemActions } from "./actions";
import { SystemState } from "./types";

const initialState: SystemState = {
  systems: [],
};

export function SystemReducer(
  state = initialState,
  action: Action,
): SystemState {
  if (isType(action, systemActions.getSystemList.done)) {
    return {
      ...state,
      systems: action.payload.result.data.map((system) => ({
        name: system.name,
      })),
    };
  }

  if (isType(action, systemActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
